import React from "react";
import { Navigate } from "react-router-dom";
import Cookies from "js-cookie";

const FreeAuthRoute = ({ auth, children, title = "" }) => {
  const token = localStorage.getItem("auth_token") || Cookies.get("auth_token");

  if (token) {
    return <Navigate to="/" />;
  } else {
    return <>{children}</>;
  }
};

export default FreeAuthRoute;
